import {ErrorCode} from '@99fun-agent/consts'
export class HttpXResponse<T>{
    private _code:number = ErrorCode.ErrClientUnknown
    private _message:string = "unknown"
    private _data:T|undefined = undefined

    /**
     * 获取错误码
     *
     * @readonly
     * @memberof HttpXResponse
     */
    public get code(){
        return this._code
    }
    /**
     * 设置错误码
     *
     * @memberof HttpXResponse
     */
    public set code(val:number){
        this._code = val
    }
    /**
     * 获取message
     *
     * @readonly
     * @memberof HttpXResponse
     */
    public get message(){
        return this._message
    }
    /**
     * 设置返回信息
     *
     * @memberof HttpXResponse
     */
    public set message(val:string){
        this._message = val
    }
    /**
     * 获取回应数据
     *
     * @readonly
     * @memberof HttpXResponse
     */
    public get data(){
        return this._data
    }
    /**
     * 设置返回数据
     *
     * @memberof HttpXResponse
     */
    public set data(val){
        this._data = val
    }

    /**
     * 是否请求成功
     * @returns 
     */
    public get isSuccess(){
        return this.code === ErrorCode.Success
    }

    /**
     * 是否无效token
     *
     * @readonly
     * @memberof HttpXResponse
     */
    public get IsJwtMissing(){
        return this.code === ErrorCode.MissingJWT
    }

    /**
     * 是否过期token
     *
     * @readonly
     * @memberof HttpXResponse
     */
    public get IsTokenExpired(){
        return this.code === ErrorCode.ErrTokenExpired
    }

    /**
     * 是否有数据
     * @returns 
     */
    public get hasData(){
        return this.data !==null && this.data!==undefined
    }

    /**
     * 转json
     * @returns 
     */
    public toString():string{
        return JSON.stringify({
            code:this.code,
            message:this.message,
            data:this.data
        })
    }

    /**
     * 打印
     */
    public log(){
        console.log({
            code:this.code,
            message:this.message,
            data:this.data
        })
    }
}